// extracted by mini-css-extract-plugin
export default {"page":"ReferralNetworkPage_page__K6JMw","pageName":"ReferralNetworkPage_pageName__MH63j","flexBox":"ReferralNetworkPage_flexBox__4iTiS"};